/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:30 GMT
 */
const tokens = {
    component: {
        tooltip: {
            boxShadow: {
                value: {
                    layers: [
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "6px",
                            blur: "9px",
                            spread: "0px",
                            color: "#161B2B24",
                        },
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "0px",
                            blur: "1px",
                            spread: "0px",
                            color: "#00000038",
                        },
                    ],
                    stringValue: "0px 6px 9px 0px #161B2B24, 0px 0px 1px 0px #00000038",
                },
                type: "shadow",
            },
            fontSize: {
                value: "1rem",
                type: "dimension",
            },
            lineHeight: {
                value: "1.5rem",
                type: "dimension",
            },
            fontWeight: {
                value: 400,
                type: "number",
            },
            paddingHorizontal: {
                value: "24px",
                type: "dimension",
            },
            paddingVertical: {
                value: "16px",
                type: "dimension",
            },
            borderRadius: {
                value: "12px",
                type: "dimension",
            },
            minWidth: {
                value: "187px",
                type: "dimension",
            },
            maxWidth: {
                value: "240px",
                type: "dimension",
            },
            maxHeight: {
                value: "170px",
                type: "dimension",
            },
            light: {
                backgroundColor: {
                    value: "#ffffff",
                    type: "color",
                },
                color: {
                    value: "#282e37",
                    type: "color",
                },
            },
            dark: {
                backgroundColor: {
                    value: "#282e37",
                    type: "color",
                },
                color: {
                    value: "#ffffff",
                    type: "color",
                },
            },
        },
    },
};
export default tokens;
